import { render } from "./SmsComposer.vue?vue&type=template&id=208ba5c9&scoped=true"
import script from "./SmsComposer.vue?vue&type=script&lang=js"
export * from "./SmsComposer.vue?vue&type=script&lang=js"

import "./SmsComposer.vue?vue&type=style&index=0&id=208ba5c9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-208ba5c9"]])

export default __exports__